import { render, staticRenderFns } from "./CompanyTable.component.vue?vue&type=template&id=4ed135a2"
import script from "./CompanyTable.component.vue?vue&type=script&lang=ts"
export * from "./CompanyTable.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports